import { Stack } from "@mui/material";
import { CommonChartProps } from "./chart.types";
import { EvolutionChart, EvolutionDataset } from "@foodpilot/foods";

type EvolutionChartProps = CommonChartProps;
export const EvolutionChart2 = (props: EvolutionChartProps) => {
    const { data, total } = props;

    const values: EvolutionDataset[] = [
        { label: "Rubrique 1", data: [10, 20] },
        { label: "Rubrique 2", data: [20, 30] },
    ];
    const labels: string[] = ["2022", "2024"];

    return (
        <Stack alignItems={"center"} justifyContent={"center"}>
            <EvolutionChart
                height="500px"
                width="500px"
                values={values}
                labels={labels}
                reverse={true}
                legend={{
                    position: "right",
                }}
            />
        </Stack>
    );
};
